<template>
    <d-list-group flush class="m-0">
        <d-list-group-item class="p-0 m-0 text-left">
            <d-form>
                <d-form-row>
                    <d-col md="6" class="form-group" v-if="expense.user">
                        <label>Użytkownik</label>
                        <d-input readonly :value="expense.user.name + ' ' + expense.user.surname"></d-input>
                    </d-col>
                    <d-col md="6" class="form-group" v-else>
                        <label>Użytkownik</label>
                        <ss-autocomplete @optionSelected="userSelectedHanlder"
                                         :placeholder="'Użytkownik'"
                                         :class="{'is-invalid' : lar_errors.has('user_id') }"
                                         :options="allUsers"
                                         :value="expense.user_id.toString()" />
                        <div class="invalid-feedback" v-text="lar_errors.get('user_id')"></div>
                    </d-col>
                    <d-col md="6" class="form-group" v-if="expense.vehicle">
                        <label>Pojazd</label>
                        <ss-input :value="expense.vehicle.model + ' ' + expense.vehicle.register_number" disabled="disabled" class="is-disabled"></ss-input>
                    </d-col>
                    <d-col md="6" class="form-group" v-if="expense.book">
                        <label>Numer księgi</label>
                        <ss-input :value="expense.book.number" disabled="disabled" class="is-disabled"></ss-input>
                    </d-col>
                </d-form-row>
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <label>Suma</label>
                        <ss-price-input :placeholder="'Suma'"
                                        v-model="expense.amount" />
                    </d-col>
                    <d-col md="6" class="form-groupi">
                        <label>Sposób płatności</label>
                        <d-select size="sm" v-model="expense.payment_type"
                                  @input="lar_errors.clear('payment_type')"
                                  :class="{'is-invalid' : lar_errors.has('payment_type') }">
                            <option value="cash">Gotówka</option>
                            <option value="transfer">Przelew</option>
                        </d-select>
                        <div class="invalid-feedback" v-text="lar_errors.get('payment_type')"></div>
                        <d-checkbox
                                class="mt-2"
                                v-if="expense.payment_type === 'transfer'"
                                :value="'1'"
                                :unchecked-value="'0'"
                                toggle
                                v-model="expense.transfer_complete">
                            Zrealizowany
                        </d-checkbox>
                        <d-checkbox
                                class="mt-2"
                                v-if="expense.payment_type === 'cash'"
                                :value="'1'"
                                :unchecked-value="'0'"
                                toggle
                                v-model="expense.cash_refunded">
                            Wykonano zwrot
                        </d-checkbox>
                    </d-col>
                </d-form-row>
                <d-form-row  v-if="expense.payment_type === 'transfer'">
                    <d-col md="6" class="form-group">
                        <ss-input v-model="expense.transfer_title" name="transfer_title" label="Tytuł przelewu" placeholder="Tytuł przelewu"></ss-input>
                    </d-col>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="expense.account_number" name="account_number" label="Numer konta" placeholder="Numer konta bankowego"></ss-input>
                    </d-col>
                </d-form-row>
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <label>Typ kosztu</label>
                        <d-select size="sm" v-model="expense.expenses_cost_type" >
                            <option :value="cost.id" v-for="cost in allCostTypes" :key="cost.id">{{ cost.name }}</option>
                        </d-select>
                    </d-col>
                    <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 1">
                        <label>Komornik</label>
                        <div class="d-flex" :class="{'is-invalid' : lar_errors.has('bailiff_id') }">
                            <v-select
                                    class="w-100"
                                    :options="allBailiffs"
                                    v-model="expense.bailiff_id"
                                    @input="lar_errors.clear('bailiff_id')"
                                    :reduce="bailiff => bailiff.id"
                                    placeholder="Wpisz dane komornika..."
                                    label="name">
                                            <span slot="no-options">
                                              Brak wyników
                                            </span>
                            </v-select>
                        </div>
                        <div class="invalid-feedback" v-text="lar_errors.get('bailiff_id')"></div>
                    </d-col>
                    <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 2">
                        <label>Nazwa sądu</label>
                        <div class="d-flex" :class="{'is-invalid' : lar_errors.has('court_id') }">
                            <v-select
                                    class="w-100"
                                    :options="allCourts"
                                    v-model="expense.court_id"
                                    @input="lar_errors.clear('court_id')"
                                    :reduce="court => court.id"
                                    placeholder="Wpisz dane sądu..."
                                    label="name">
                                            <span slot="no-options">
                                              Brak wyników
                                            </span>
                            </v-select>
                        </div>
                        <div class="invalid-feedback" v-text="lar_errors.get('court_id')"></div>
                    </d-col>
                    <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 3">
                        <ss-input v-model="expense.recipent" name="recipent" label="Odbiorca" placeholder="Odbiorca"></ss-input>
                    </d-col>
                </d-form-row>
                <div class="form-group">
                    <ss-textarea v-model="expense.comment"
                                 name="comment"
                                 label="Komentarz"
                                 placeholder="Komentarz"></ss-textarea>
                </div>
            </d-form>
        </d-list-group-item>
    </d-list-group>
</template>

<script>
  import LarErrors from '../../helpers/Errors';
  import expenseUtil from '../../utils/expense'
  import SsPriceInput from '../../components/common/SsPriceInput'
  import SsAutocomplete from '../../components/common/SsAutocomplete'
  import SchedulesAutocomplete from '../../components/common/SsSchedulesAutocomplete';
  import SsNameAutocomplete from '../../components/common/SsNameAutocomplete';
  import SsBailiffsAutocomplete from "../../components/common/SsBailiffsAutocomplete";
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "expenseNew",
    components: {
      LarErrors,
      SsPriceInput,
      SsAutocomplete,
      SchedulesAutocomplete,
      SsNameAutocomplete,
      SsBailiffsAutocomplete
    },
    props: {
      props: {
        type: Object,
        default: () => {}
      },
    },
    data(){
      return{
        fetched: false,
        lar_errors: LarErrors,
        submitting: false,
        cost_types: [],
        expense: _.clone(expenseUtil),
        executions: [],
      }
    },
    computed: {
      ...mapGetters([
        'allUsers',
        'allCostTypes',
        'allCourts',
        'allBailiffs'
      ]),
    },
    methods: {
      ...mapActions([
        'getAllUsers',
        'getAllCostTypes',
        'getAllCourts',
        'getAllBailiffs'
      ]),
      fetchData() {
        axios.post('api/expenses/item/' + this.id).then(response => {
          this.expense = response.data.data;
          this.fetched = true;
        }).catch((errors) =>{
          this.fetched = true;
          console.log(errors);
        })
      },
      submitForm(){
        this.submitting = true;
        axios.post('api/expenses/store', this.expense).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Wydatek został dodany.',
            showConfirmButton: true,
          }).then(() => {
            this.$router.push({name: 'expenses-list'});
          });
          this.submitting = false;
        }).catch((error) =>{
            Vue.swal({
                type: 'error',
                title: error.response.data.message,
                html: Vue.transformErrorsToHtml(error.response.data.errors),
                showConfirmButton: true,
            });
            this.submitting = false;
            LarErrors.record(error.response.data.errors)
        })
      },
      userSelectedHanlder(id) {
        this.expense.user_id = id
      },
      scheduleSelected(a, b){
        a.schedule_id = b.id;
        axios.post('api/contracts-case/get-cases/' + b.id).then(response => {
          this.executions = response.data;
        }).catch((errors) =>{
          console.log(errors);
        })
      },
      courtSelectedHandler(court) {
        this.court_modal = false;
        this.expense.court_id = court.id
      },
    },
    mounted(){
      this.expense = this.props ? this.props : this.expense;
      this.getAllCostTypes();
      this.getAllCourts();
      this.getAllBailiffs();
      this.getAllUsers();
      this.$bus.$on('new-expense-save', this.submitForm);
      this.$bus.$on('edit-expense-save', this.submitForm);
      this.fetched = true;
    },
    watch: {
      props: {
        handler: function (to) {
          this.expense = to;
          this.$forceUpdate();
        },
        immediate: false,
        deep: true
      }
    },
    beforeDestroy() {
      this.expense =_.clone(expenseUtil);
      this.fetched = false;
    }

  }
</script>
